'use strict';
/*
 Enhances a
 @param buttonDescr Object
 @return $
 */
Odigeo.UIElements.enhanceDatepicker = function($input, newOptions) {
    var options;
    var $wrapper;
    var $calWrapper;
    var $legendSquare;
    var $holiday;
    var $footer;
    var $close;
    var $field;
    var $text;
    var $title;
    var $rightButton;
    var $rightIcon;
    var handler;
    var toggle;
    var open;
    var close;
    var clear;
    var config;
    var setType;
    var setSize;
    var changeButton;
    var clearUnsortedDates;
    var enable;
    var disable;
    var special;
    var refresh;
    var _changeHandler;
    var _toggleActivation;
    var addSpecialOption;
    var _closeHandler;
    var toggleSpecialOption;
    var _getInputText;
    var showError;
    var removeError;
    var skipMonth;
    var eventListener = Odigeo._.extend({}, Odigeo.Events);

    if ($input.attr('data-skip-enhance') === 'true') {
        return $input;
    }

    $input.getCalendar = Odigeo._.once(Odigeo.UIElements.getCalendar);
    $input.attr({'data-skip-enhance': true});

    $input.toggleClass('prisma', newOptions.isCssVariationHeaderDesktop);

    options = {
        disabled: false,
        deactivated: false,
        type: 'single',
        numCals: 2,
        closeDelay: 300,
        animate: false,
        dates: [null],
        closeButton: false,
        specialToOpen: false,
        closeText: '',
        especialOptions: null,
        inputClass: newOptions.isCssVariationHeaderDesktop ?
            'od-ui-datepicker-field wl-bookingcom-input cobalt-variation' :
            'od-ui-datepicker-field wl-bookingcom-input',
        inputTextClass: newOptions.isCssVariationHeaderDesktop ?
            'od-ui-datepicker-display cobalt-variation' :
            'od-ui-datepicker-display',
        rightButtonClass: 'od-ui-datepicker-rightButton',
        leftButtonClass: newOptions.isCssVariationHeaderDesktop ? 'odf-hidden' : 'od-ui-datepicker-leftButton',
        wrapperClass: `od-ui-datepicker-wrapper ${newOptions.isCssVariationHeaderDesktop ? 'prisma' : ''}`,
        containerClass: 'od-ui-datepicker-container datepicker',
        hasCountryHolidays: !Odigeo._.isEmpty(Odigeo.Utils.calendarHolidays.countryHolidays),
        hasRegionHolidays: !Odigeo._.isEmpty(Odigeo.Utils.calendarHolidays.regionHolidays),
        flexible: false,
        swipe: 'true',
        tabToggle: false,
        skipHide: false,
        enableBlur: true,
        errorIncomplete: !Odigeo._.isEmpty(newOptions.errorMessages) ? newOptions.errorMessages.dateError : null,
    };

    options = Odigeo._.extend(options, Odigeo.parseOptions($input.data()), newOptions);

    $wrapper = $('<div>', {'class': options.containerClass});
    if (Odigeo._.has(options, 'tabindex')) {
        $wrapper.attr('tabindex', options.tabindex);
    }

    $calWrapper = $('<div>', {});

    if (newOptions.isCssVariationHeaderDesktop) {
        $calWrapper.toggleClass('prisma_test od-prisma-calendar-wrapper prisma-elevation-2 prisma-dropdown prisma-dropdown-overflow-unset');
    } else {
        $calWrapper.toggleClass('od-ui-calendar-wrapper');
    }

    if (options.closeButton || options.hasCountryHolidays || options.hasRegionHolidays || options.flexible) {
        $footer = $('<div>', {'class': 'od-ui-datepicker-footer datepicker_footer'});

        if (options.closeButton) {
            $close = $('<div>', {'class': 'od-footer-options-container'});
            $close.append($('<button>', {'class': 'od-ui-datepicker-close-button', 'text': options.closeButton}));
            $footer.append($close);
        }

        if (options.hasCountryHolidays || options.hasRegionHolidays) {
            $holiday = $('<div>', {'class': 'od-ui-datepicker-holiday-legend-wrapper'});
            $legendSquare = $('<div>', {'class': 'od-ui-datepicker-legend-square'});
            if (options.hasSquareLegend) {
                $holiday.addClass('od-ui-datepicker-legend-square-wrapper');
            }
            if (options.hasCountryHolidays) {
                $holiday.append($('<div>', {
                    'class': 'odf-space-outer-bottom-xs od-ui-datepicker-holiday-legend legend-country',
                    'text': Odigeo.UIElements.translations.holidayLegends.country,
                }).prepend($legendSquare.clone().append($('<span>', {'class': 'corner-mark'}))));
            }
            if (options.hasRegionHolidays) {
                $holiday.append($('<div>', {
                    'class': 'od-ui-datepicker-holiday-legend legend-region',
                    'text': Odigeo.UIElements.translations.holidayLegends.region,
                }).prepend($legendSquare.clone().append($('<span>', {'class': 'corner-mark'}))));
            }
            $footer.prepend($holiday);
        }
        $calWrapper.append($footer);
    }

    $text = $('<div>', {'class': options.inputTextClass, 'text': options.placeholder});
    if (!Odigeo._.isUndefined(options.title)) {
        $title = $('<div>', {'class': 'od-ui-datepicker-display-title datepicker_title', 'text': options.title});
    }

    $rightIcon = $('<span>', {'class': 'ficon'});
    $rightButton = $('<div>', {'class': options.rightButtonClass}).append($rightIcon);
    $field = $('<div>', {'class': options.inputClass + ' placeholder'})
        .append($('<div>', {'class': options.leftButtonClass})
            .append($('<span>', {'class': 'ficon', 'text': 'z'})))
        .append($title)
        .append($text)
        .append($rightButton);

    if (options.disabled) {
        $wrapper.addClass('disabled');
    }

    if (!Odigeo._.isUndefined(options.buttonIcon)) {
        $wrapper.addClass('hasButton');
        $rightIcon.text(options.buttonIcon);
    }

    $input.replaceWith($wrapper);
    $wrapper
        .append(options.skipHide ? $input.addClass('od-ui-datepicker-input') : $input.hide())
        .append($('<div>', {'class': options.wrapperClass})
            .append($field)
            .append($calWrapper.removeClass('open').addClass('closed'))
        );

    if (!Odigeo._.isUndefined(options.errorIncomplete)) {
        $wrapper.append($('<div>', {
            'class': 'od-ui-datepicker-error',
            'data-error': 'incomplete',
            'text': options.errorIncomplete,
        }));
    }

    $input.data(options);

    _closeHandler = function() {
        close();
    };

    _getInputText = function(options, date) {
        var format = options.format || Odigeo.Utils.masks.datepicker;
        var placeHolder = options.dateTitleFocus || '';

        return placeHolder + Odigeo.Utils.formatDate(date, format, true);
    };

    _changeHandler = function(evt, value, silent) {
        var changeData = {};
        var isPlaceholder = false;
        var dateText;
        var modified;
        var selectedDate = null;

        if (evt) {
            evt.stopPropagation();
        }

        // null for clearing
        if (Odigeo._.isNull(value)) {
            if (options.index in options.dates) {
                options.dates[options.index] = null;
            }
            dateText = options.placeholder;
            isPlaceholder = true;
        } else {
            // date for direct setting
            if (Odigeo._.isDate(value)) {
                options.dates[options.index] = value;
                selectedDate = value;
                dateText = _getInputText(options, selectedDate);
                // object for alteration from calendar
            } else if (Odigeo._.isObject(value)) {
                options.dates = clearUnsortedDates(value.dates);
                options.index = value.index;
                modified = value.modified;
                selectedDate = Odigeo._.has(value, 'selectedDate') ? value.selectedDate : value.dates[value.index];
                if (!Odigeo._.isUndefined(selectedDate)) {
                    options.dates[options.index] = selectedDate;
                    dateText = _getInputText(options, selectedDate);
                } else {
                    isPlaceholder = true;
                }
            } else {
                dateText = options.placeholder;
                isPlaceholder = true;
            }

            if (!Odigeo._.isUndefined(options.dates) && Odigeo._.isDate(options.dates[options.index])) {
                $input.data('dates', options.dates);
            }
        }
        $text.html(dateText);
        $field.toggleClass('placeholder', isPlaceholder);

        if (!silent) {
            changeData.dates = options.dates;
            changeData.index = options.index;
            changeData.selectedDate = selectedDate;
            if (!Odigeo._.isUndefined(modified)) {
                changeData.modified = modified;
            }

            if ($wrapper.hasClass('active')) {
                Odigeo._.delay(function() {
                    $input.trigger('blur');
                    $input.trigger('change', changeData);
                    $wrapper.removeAttr('data-error');
                }, options.closeDelay, this);
            } else {
                $input.trigger('change', changeData);
                $wrapper.removeAttr('data-error');
            }
        }
    };

    config = function(evt, params) {
        Odigeo._.extend(options, $input.data(), params);
        $input.data(options);

        if (params.dates && !params.dates[options.index]) {
            $input.trigger('invalid');
        }

        if (params.type) {
            setType(params.type);
        }
        if (params.size) {
            setSize(params.size);
        }
        if (!Odigeo._.isUndefined(params.button)) {
            changeButton(params.button);
        }
        if (!Odigeo._.isUndefined(params.value)) {
            _changeHandler(evt, params.value, params.silent);
        }
        if (params.dates) {
            options.dates[options.index] = params.dates[options.index];
        }
        if (params.refresh) {
            refresh(params.silent || $wrapper.hasClass('disabled'));
        }
        if (params.placeholder) {
            refresh(true);
        }
    };

    clear = function(evt) {
        if (evt) {
            evt.stopPropagation();
        }
        if (options.index in options.dates) {
            options.dates[options.index] = null;
        }
        $text.html(options.placeholder);
        $field.toggleClass('placeholder', true);
    };

    refresh = function(silent) {
        _changeHandler(null, options.dates[options.index], silent);
    };

    changeButton = function(value) {
        if (Odigeo._.isString(value) || Odigeo._.isNumber(value)) {
            $wrapper.addClass('hasButton');
            $rightIcon.text(value);
        } else {
            $rightIcon.empty();
            $wrapper.removeClass('hasButton');
        }
    };

    setType = function(type) {
        $input.data('type', type);
        switch (type) {
            case 'single':
                setSize(1);
                break;
            case 'dual':
            case 'multiple':
                setSize(2);
                break;
        }
    };

    setSize = function(size) {
        var type = $input.data('type');
        var dates = $input.data('dates');

        switch (type) {
            case 'dual':
                if (size !== 2) {
                    throw new Error('Cannot set size for a round trip to other than two');
                }
                break;
            case 'multiple':
                if (size < 2) {
                    throw new Error('Cannot set size for a multi trip to less than two');
                }
                break;
            default:
                if (size <= 0) {
                    throw new Error('Cannot set a size to less than one');
                }
                break;
        }

        dates = dates.slice(0, 1);

        while (dates.length < size) {
            dates.push(null);
        }

        options.dates = dates;
        $input.data('dates', dates);
    };

    toggle = function() {
        Odigeo.trigger('datepicker:toggleDatepicker', $input.data('key'));
        if ($wrapper.hasClass('active') && !options.tabToggle) {
            $input.trigger('blur');
        } else if (!($wrapper.hasClass('disabled') || $input.data('disabled') || $input.data('deactivated'))) {
            $input.triggerHandler('focus');
        }
    };

    special = function(evt) {
        if (!$wrapper.hasClass('disabled')) {
            if (!options.specialToOpen) {
                evt.stopPropagation();
            }
            $input.trigger('special');
        }
    };

    const isOpen = function() {
        return $wrapper.hasClass('active') && $wrapper.parent().addClass('active');
    };

    open = function() {
        var side = $input.data('side');
        var calendar = $input.getCalendar(options.swipe);
        var data = $input.data();

        if ( newOptions.isCssVariationHeaderDesktop ) {
            if ( isOpen() ) {
                $input.trigger('blur');
                return;
            }
        }

        data.dates = options.dates;

        calendar.show(data);
        $wrapper.addClass('active');
        $wrapper.parent().addClass('active');

        if (['left', 'right'].includes(side)) {
            $calWrapper.attr('data-side', side);
        } else {
            $calWrapper.removeAttr('data-side');
        }

        if (newOptions.isCssVariationHeaderDesktop) {
            $calWrapper.toggleClass( 'od-prisma-calendar-multidestination', $input.data('type') ==='multiple' );

            $calWrapper.find('.datepicker_footer').toggleClass('odf-hidden', true);

            $calWrapper.prepend(calendar.$cal);

            $calWrapper.removeClass('closed').addClass('open');
        } else {
            if (options.closeButton || options.hasCountryHolidays || options.hasRegionHolidays || options.flexible) {
                $calWrapper.find('.datepicker_footer').before(calendar.$cal);
                $calWrapper.removeClass('closed').addClass('open');
            } else {
                $calWrapper.append(calendar.$cal).removeClass('closed').addClass('open');
            }

            calendar.$cal.off('change').on('change', Odigeo._.bind(_changeHandler, this));
        }

        calendar.$cal
            .off('change').on('change', Odigeo._.bind(_changeHandler, this))
            .off('close').on('close', Odigeo._.bind(_closeHandler, this));

        var $heightCal = $calWrapper.offset().top + $calWrapper.height();

        Odigeo.trigger('openPaneltoCalendar', $heightCal);
    };

    close = function() {
        $calWrapper.removeClass('open').addClass('closed');
        $wrapper.removeClass('active');
        $wrapper.parent().removeClass('active');
        Odigeo.trigger('closePaneltoCalendar');
    };

    enable = function() {
        $wrapper.removeClass('disabled');
        options.disabled = false;
        $input.data('disabled', false);
    };

    disable = function() {
        close();
        $wrapper.addClass('disabled');
        $input.data('disabled', true);
        options.disabled = true;
    };

    _toggleActivation = function(activated) {
        close();
        options.activated = !activated;
        $input.data('deactivated', !activated);
        $wrapper.off(Odigeo.Events.tap);

        if (activated) {
            $wrapper
                .on(Odigeo.Events.tap, '.' + options.inputClass.replaceAll(' ', '.'), Odigeo._.bind(toggle, this))
                .on(Odigeo.Events.tap, '.' + options.rightButtonClass.replace(' ', '.'), Odigeo._.bind(special, this))
                .on(Odigeo.Events.tap, '.od-ui-datepicker-close-button', Odigeo._.bind(close, this));
        }
    };

    clearUnsortedDates = function(dates) {
        var left;
        var right;

        for (var i = 1; i < dates.length; i++) {
            left = Odigeo._.max(Odigeo._.filter(dates.slice(0, i), Number));
            right = dates[i];
            if (left > right) {
                dates[i] = null;
                var $dateText = $('#date_selection' + i);

                $dateText.find('.date')
                    .text($dateText.data(dates.length > 2 && i === 1 ? 'placeholder2' : 'placeholder'))
                    .addClass('placeholder_date');
            }
        }
        return dates;
    };

    addSpecialOption = function(specialOptions) {
        Odigeo._.each(specialOptions, function(specialOption) {
            var $specialOptionsDom = specialOption.dom;
            var $specialOptionsInjectionSelector = specialOption.injectionSelector;
            $wrapper.find($specialOptionsInjectionSelector)[specialOption.injectionPosition === 'prepend' ? 'prepend' : 'append']($specialOptionsDom);

            if (specialOption.action) {
                $(specialOption.action.selector).on(specialOption.action.evt, function() {
                    Odigeo.trigger(specialOption.action.trigger);
                });
            }
        });
    };

    toggleSpecialOption = function(selector, value) {
        $(selector).toggleClass('odf-hidden', value);
    };

    showError = function(e, error) {
        $wrapper.attr('data-error', error);
    };

    removeError = function() {
        $wrapper.removeAttr('data-error');
    };

    handler = {
        addSpecialOption: function(specialOptions) {
            Odigeo._.bind(addSpecialOption, this, specialOptions)();
        },
        hideSpecialOption: function(selector) {
            Odigeo._.bind(toggleSpecialOption, this, selector, true)();
        },
        showSpecialOption: function(selector) {
            Odigeo._.bind(toggleSpecialOption, this, selector, false)();
        },
        clear: Odigeo._.bind(clear, this),

    };

    skipMonth = function() {
        $input.getCalendar().skipMonth();
    };

    const toggleOpen = function() {
        isOpen() ? close() : open();
    };

    const onFocus = function(e) {
        if (e) {
            e.stopImmediatePropagation();
        }
        toggleOpen(e);
    };

    eventListener.listenTo(Odigeo.Events.fake, 'fake:blur', function(e) {
        if (options.enableBlur && !$wrapper.get(0).contains(e.target) && !$wrapper.parent().hasClass('calendar-tab')) {
            close();
        }
    });

    $input
        .on('open', Odigeo._.bind(open, this))
        .on('close', Odigeo._.bind(close, this))
        .on('blur', Odigeo._.bind(close, this))
        .on('enable', Odigeo._.bind(enable, this))
        .on('disable', Odigeo._.bind(disable, this))
        .on('activate', Odigeo._.bind(_toggleActivation, this, true))
        .on('deactivate', Odigeo._.bind(_toggleActivation, this, false))
        .on('config', Odigeo._.bind(config, this))
        .on('refresh', Odigeo._.bind(refresh, this))
        .on('clear', Odigeo._.bind(clear, this))
        .on('clearError', Odigeo._.bind(removeError, this))
        .on('error', Odigeo._.bind(showError, this))
        .on('skipMonth', Odigeo._.bind(skipMonth, this));

    if (newOptions.isCssVariationHeaderDesktop) {
        $input
            .on('focus', Odigeo._.bind(onFocus, this))
            .on('tap', Odigeo._.bind(onFocus, this));
    } else {
        $input
            .on('focus', Odigeo._.bind(open, this));
    }

    _toggleActivation(!options.deactivated);

    return handler;
};
